import { Box, Typography } from "@material-ui/core"
import React, { FunctionComponent } from "react"
import { MaxOperationsRemainingLabel } from "./MaxOperationsRemainingLabel"
import { OperationsProgressBar } from "./OperationsProgressBar"
import { OperationsProgressLabel } from "./OperationsProgressLabel"

interface OperationsProgressCardProps {
    maxOperations: number
    currentOperations: number
    isCurrentMonth: boolean
}

export const OperationsProgressCard: FunctionComponent<OperationsProgressCardProps> = ({
    maxOperations,
    currentOperations,
    isCurrentMonth
}) => {
    return (
        <>
            <Box display="flex" alignItems="flex-start" flexDirection="column">
                <Box paddingBottom=".5em">
                    <Typography variant="body1">Total Operations</Typography>
                </Box>
                <Box paddingBottom=".5em">
                    {isCurrentMonth && (
                        <MaxOperationsRemainingLabel
                            maxOperations={maxOperations}
                            currentOperations={currentOperations}
                        />
                    )}
                </Box>
            </Box>
            <Box display="flex" alignItems="center">
                <Box flex={1} mr={1}>
                    <OperationsProgressBar
                        maxOperations={maxOperations}
                        currentOperations={currentOperations}
                    />
                </Box>
                <Box>
                    <OperationsProgressLabel
                        maxOperations={maxOperations}
                        currentOperations={currentOperations}
                    />
                </Box>
            </Box>
        </>
    )
}
